// src/components/MainPage.js

import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// Imports adjusted for relative paths within /components folder
import Header from "./Header"; 
import Shelves from "./Shelves"; 

const MainPage = ({ books, updateBookShelf }) => {
    return (
        <div className="list-books">
            <Header />
            <div className="list-books-content">
                {/* Shelves component is responsible for filtering and displaying the 3 shelves */}
                <Shelves books={books} updateBookShelf={updateBookShelf} />
            </div>
            
            {/* Link to Search Page */}
            <div className="open-search">
                <Link to="/search">
                    <button>Add a book</button>
                </Link>
            </div>
        </div>
    );
};

MainPage.propTypes = {
    books: PropTypes.array.isRequired,
    updateBookShelf: PropTypes.func.isRequired,
};

export default MainPage;